import { render, staticRenderFns } from "./CardMegaMenuLevelOne.vue?vue&type=template&id=0c2e0738&scoped=true&"
import script from "./CardMegaMenuLevelOne.vue?vue&type=script&lang=ts&"
export * from "./CardMegaMenuLevelOne.vue?vue&type=script&lang=ts&"
import style0 from "./CardMegaMenuLevelOne.vue?vue&type=style&index=0&id=0c2e0738&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2e0738",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsMegaMenuCard: require('/var/www/packages/theme/components/atoms/MegaMenuCard.vue').default})
